<div class="page-layout simple fullwidth" fxLayout="column" style="background-color: white;">
    <div class="center">
        <div class="content-card" class="center " fxLayout="row wrap" style="padding-top: 10%;">
            <br>
            <div fxFlex="100">
                <img style="width: 200px; text-align: center; display:block;
                margin:auto;" src="assets/logo_GO2.jpg">
                <div fxLayout="column" fxLayoutAlign="end center" style="width: 100%; padding-top: 5%;">
                    <mat-form-field appearance="outline" style="width: 30%;">
                        <mat-label>{{'LOGIN.FORM.INPUT.LANGSEL' | translate}}</mat-label>
                        <mat-select [(value)]="selectedLanguage" required>
                            <mat-option *ngFor="let lang of languages" (click)="setLanguage(lang.id)" [value]="lang.id">
                                {{'SELECTOR.'+lang.id | translate}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">language</mat-icon>
                        <mat-error>idioma</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%; padding-bottom: 3%;">
                    <h3 style="font-weight: bolder;">{{'LOGIN.PASSWORD.AVISO' | translate}}</h3>
                    <mat-form-field appearance="legacy" flex="80">
                        <mat-label>{{'LOGIN.PASSWORD.PLACERHOLDER' | translate}}</mat-label>
                        <input matInput [(ngModel)]='userGo' (blur)="validarBtn()" key-down="validarBtn()">
                        <mat-icon matSuffix>email</mat-icon>
                    </mat-form-field>
                    <button mat-raised-button color="warn" (click)="buscarCorreo()" [disabled]="disableBtn" style="background-color: red; color:white">{{'LOGIN.PASSWORD.BTN' | translate}}</button>
                </div>
                <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%;" *ngIf="showMessage">
                    <h3 style="font-weight: bolder; color: #22bb33" *ngIf="typeMensaje && !null">{{ mensajeCorreo | translate}}</h3>
                    <h3 style="font-weight: bolder; color: #bb2124" *ngIf="!typeMensaje && !null">{{ mensajeCorreo | translate}}</h3>
                </div>
                <div *ngIf="showMessage" class="subtitle" fxLayoutAlign="center center"><a class="linkPage" style="color: #3366BB;" (click)="goPassword()">{{'LOGIN.FORM.LOGIN' | translate}}</a></div>
            </div>
        </div>
    </div>
</div>